import { useState, useEffect } from "react";

const PongAgeCounter = () => {
  const pongYear = 1972;

  const calculateAge = () => new Date().getFullYear() - pongYear;

  const [age, setAge] = useState(calculateAge());

  useEffect(() => {
    const interval = setInterval(() => {
      setAge(calculateAge());
    }, 1000 * 60 * 60 * 24); // updates every day

    return () => clearInterval(interval);
  }, []);

  return <>{age}</>; // only outputs the number
};

export default PongAgeCounter;
